<!-- eslint-disable vue/no-multiple-template-root -->
<template lang="pug">
div(class='md:flex')
  div(class='flex-none md:p-3 md:pl-0 lg:pl-3')
    img(
      v-if='cartItem.image'
      :src='urls.getImageUrl(cartItem.image.key, cartItem.image.filename, 474, 354)'
      width='474'
      height='354'
      alt='product image'
      class='border w-full max-w-[474px] md:max-w-[142px] lg:max-w-[120px] xl:max-w-[142px]'
    )

  div(class='lg:w-full')
    div(class='lg:flex lg:justify-between')
      div(class='pt-2 pb-6 text-sm col-span-4 md:p-3 md:col-span-2 lg:col-span-1')
        div(class='space-y-1')
          div(class='text-xl font-bold md:text-base')
            UniversalLink(data-testid='productName' :link='`/p/${cartItem.productLineSlug}/${cartItem.skuSlug}/`')
              InlineHtml(:text='cartItem.productName')

          div
            div(class='text-black font-bold') Part #
            //- API doesn't return mpn so do we need this?
            div {{ cartItem.mpn || cartItem.sku }}

          div(v-if='cartItem.fitmentData && cartItem.fitmentData.year' class='relative')
            FitmentGuaranteedFit(
              v-if='$sitewideConfig.config.guaranteedFitEnabled && cartItem.guaranteedFit'
              :type='cartItem.guaranteedFit'
            )
            div(v-else class='text-black font-bold') Vehicle
            div
              | {{ cartItem.fitmentData.year }}
              | {{ cartItem.fitmentData.makeName }}
              | {{ cartItem.fitmentData.modelName }}
              InlineHtml(
                v-if='cartItem.fitmentData.bedName'
                class='before:content-[",_"]'
                :text='cartItem.fitmentData.bedName'
              )
              InlineHtml(
                v-if='cartItem.fitmentData.bodyName'
                class='before:content-[",_"]'
                :text='cartItem.fitmentData.bodyName'
              )
              InlineHtml(
                v-if='cartItem.fitmentData.engineName'
                class='before:content-[",_"]'
                :text='cartItem.fitmentData.engineName'
              )
              InlineHtml(
                v-if='cartItem.fitmentData.appNote'
                class='before:content-[",_"]'
                :text='cartItem.fitmentData.appNote'
              )

          Shipping(:data='cartItem' @refresh='cart.refresh')
            SameDayShippingLogo(v-if='hasSameDayShipping' class='w-full max-w-[100px]')

          template(v-if='cartItem.info')
            template(v-for='attribute in cartItem.info' :key='`${attribute.key}-${attribute.value}`')
              div(class='uppercase text-black font-bold') {{ attribute.key }}
              div
                InlineHtml(:text='attribute.value')

          div(v-if='cartItem.meta?.notes')
            div(class='uppercase text-black font-bold') Notes
            div
              InlineHtml(:text='cartItem.meta.notes')

          //- Promo
          div(v-if='cartItem.discount?.text' class='text-success')
            InlineHtml(:text='cartItem.discount.text')

          div(v-if='cartItem.promo' class='text-success')
            InlineHtml(:text='cartItem.promo.text')
            br
            a(v-if='cartItem.promo.url' :href='cartItem.promo.url' target='__blank' class='text-inherit') More information

      div(class='flex-none font-bold text-right hidden md:p-3 lg:block')
        div(class='text-black' :class='{ "line-through": cartItem.originalPrice !== cartItem.salePrice }') {{ formatCents(cartItem.originalPrice) }}
        div(v-if='cartItem.discount' class='text-sm text-danger-dark') {{ formatCents(cartItem.discount.amount * -1) }}

        ExtendPrice(
          v-if='isIntegrationEnabled("extend") && cartItem?.warranty'
          :warranty='cartItem.warranty'
          show-item-price
        )

        InstallernetPrice(
          v-if='isIntegrationEnabled("installernet") && cartItem?.installation'
          :installation='cartItem.installation'
          show-item-price
        )

    div(class='pb-6 col-span-full md:p-3 md:col-span-4 md:col-start-2 md:order-last lg:pb-4')
      div(class='max-w-xs space-y-6')
        ExtendCart(v-if='isIntegrationEnabled("extend")' :item='cartItem')

        ClientOnly
          Installernet(
            v-if='isIntegrationEnabled("installernet") && cartItem.shipMethod === "EXPEDITED"'
            :item='cartItem'
          )

div(class='flex justify-between text-center md:p-3')
  CheckoutItemActions(:item='cartItem')
  div(data-testid='cartSubtotal' class='self-center font-bold text-danger-dark md:hidden') {{ formatCents(cartItem.saleSubtotal) }}

div(class='p-3 hidden md:block')
  div(data-testid='cartSubtotal' class='font-bold text-right text-danger-dark lg:text-black') {{ formatCents(cartItem.saleSubtotal) }}
</template>

<script setup lang="ts">
const { $sitewideConfig } = useNuxtApp()
const { isIntegrationEnabled } = useUtils()
const urls = useUrls()
const cart = useCart()

const { cartItem } = defineProps<{
  cartItem: CartItem
}>()

const hasSameDayShipping = computed(
  () => $sitewideConfig.config.sameDayShippingEnabled && cartItem.shipMethod === 'EXPEDITED'
)
</script>
